<template>
  <div class="baseball-no-data" tabindex="0">
    <slot name="icon"></slot>
    <p>{{title}}</p>
    <slot name="button"></slot>
  </div>
</template>
<script>
  export default {
    name: 'EmptyBaseballCell',
    props: {
      title: {
        type: String
      }
    }
  }
</script>
